import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { SimilarWorkOrder } from '../models/work-order.model';
import {
  ClearUserSelectedDataRequest,
  ClearOperationResponse,
} from '../models/requests/clear-user-selected-data-request';

@Injectable({
  providedIn: 'root',
})
export class SimilarWorkOrderService {
  constructor(private apiService: ApiService) {}

  public updateSelection(
    similarWorkOrderUid: string,
    isSelected: boolean,
  ): Observable<SimilarWorkOrder> {
    return this.apiService.post<SimilarWorkOrder>(
      `/SimilarWorkOrder/UpdateSimilarWorkOrderSelection`,
      {
        SimilarWorkOrderUid: similarWorkOrderUid,
        IsSelected: isSelected,
      },
    );
  }

  public clearSelections(
    request: ClearUserSelectedDataRequest,
  ): Observable<ClearOperationResponse> {
    return this.apiService.post<ClearOperationResponse>(
      `/SimilarWorkOrder/ClearSelections`,
      request,
    );
  }
}
